import { isNullOrWhiteSpace } from 'owa-string-utils';
import { getParsedQueryStringFromUrl } from './getParsedQueryStringFromUrl';
import { isLinkPrefixedWithBaseUrl } from './isLinkPrefixedWithBaseUrl';
import isSharePointLink from './isSharePointLink';

const OFFICE_LINK_BASE_URL = 'https://www.office.com';
export function isOfficeSharePointLink(url: string): boolean {
    if (!isLinkPrefixedWithBaseUrl(url, OFFICE_LINK_BASE_URL)) {
        return false;
    }

    const parsed = getParsedQueryStringFromUrl(url);
    if (!isNullOrWhiteSpace(parsed?.file)) {
        const fileUrl = decodeURI(parsed?.file);
        return isSharePointLink(fileUrl);
    }

    return false;
}
